import React, { useMemo } from 'react';
import BannerItem, { BannerItemProps } from './_banner-item';
import clsx from 'clsx';
interface BannerBlockProps {
  systemId: string;
  banners: BannerItemProps[];
  numPerRow: number;
  fullwidth: boolean;
}

const BannerBlock = (props: BannerBlockProps) => {
  const { banners, numPerRow, systemId, fullwidth } = props;
  const cellsClass = useMemo(() => {
    switch (numPerRow) {
      case 1:
      default:
        return 'grid-cols-1';
      case 2:
        return 'grid-cols-1 md:grid-cols-2';
      case 3:
        return 'md:grid-cols-3';
      case 4:
        return 'grid-cols-2 md:grid-cols-4';
      case 5:
        return 'grid-cols-2 md:grid-cols-6 lg:grid-cols-5';
      case 6:
        return 'grid-cols-2 md:grid-cols-3 lg:grid-cols-6';
    }
  }, [numPerRow]);

  return banners?.length > 0 ? (
    <div className={clsx('container', fullwidth && 'px-0')}>
      <div className={`grid ${cellsClass}`}>
        {banners.map((banner, idx) => (
          <BannerItem
            {...banner}
            numPerRow={numPerRow}
            key={'banner-block' + idx + systemId}
          />
        ))}
      </div>
    </div>
  ) : null;
};

export default BannerBlock;
